import axios from "axios";
import React, { useEffect, useState } from "react";
import FormWithCountrySelector from "./FormWithCountrySelector";
import SearchBar from "./SearchBar";

const baseUrl = import.meta.env.VITE_API_URL;

interface ApplicantDetailsProps {
  setSelectedApplicant: (applicant: any) => void; // Replace 'any' with the specific type if known
  applicantFormData?: any; // Replace 'any' with the specific type if known
  setApplicantFormData: (data: any) => void; // Replace 'any' with the specific type if known
  nameError: any;
  setNameError: any;
  passportNumberError: any;
  setPassportNumberError: any;
  countryError: boolean;
  setCountryError: (val: boolean) => void;
}

const ApplicantDetails: React.FC<ApplicantDetailsProps> = ({
  setSelectedApplicant,
  applicantFormData,
  setApplicantFormData,
  nameError,
  setNameError,
  passportNumberError,
  setPassportNumberError,
  countryError,
  setCountryError,
}) => {
  const [selected, setSelected] = useState<string>(); // ⬅️ you were missing this!
  const [selectedUser, setSelectedUser] = useState<{
    applicantid: string;
    name: string;
    passport: string;
    country?: string;
  } | null>(null);
  const [check, setCheck] = useState<boolean>();
  const [applicantData, setApplicantData] = useState<{
    applicants: {
      applicantid: string;
      name: string;
      passport: string;
      country?: string;
    }[];
    count: number;
  } | null>(null);
  const [showAll, setShowAll] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");

  const filteredUsers = applicantData?.applicants?.filter((user) =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const displayedUsers = showAll
    ? filteredUsers || applicantData?.applicants
    : filteredUsers?.slice(0, 2) ||
      applicantData?.applicants?.slice(0, 2) ||
      [];

  const handleViewMore = () => {
    setShowAll(true);
  };

  useEffect(() => {
    fetchApplicants();
  }, []);

  const fetchApplicants = async () => {
    const UUID = localStorage.getItem("uuid");
    try {
      const response = await axios.get(`${baseUrl}/api/cart/getAllApplicant`, {
        params: {
          uuid: UUID,
        },
      });
      if (response.data) {
        setApplicantData(response.data);
        setSelectedUser(response.data?.applicants?.[0]);
        setSelectedApplicant(response.data?.applicants?.[0]);
        setApplicantFormData(response.data?.applicants?.[0])
        setCheck(true);

        setSelected("existing");
      }
    } catch (error) {
      setSelected("new");
      setCheck(false);
      console.error("Error fetching applicants:", error);
    }
  };

  return (
    <div className="bg-white rounded">
      {/* Selection Cards */}
      <div className="row g-3 pb-1 mt-1">
        {check === true && (
          <div className="col">
            <div
              className={`d-flex align-items-center gap-3 pk-card-nw p-2 rounded-4 ${
                selected === "existing" ? "active " : ""
              }`}
              style={{
                cursor: "pointer",
                borderColor:
                  selected === "existing" ? "#385986" : "transparent",
              }}
              onClick={() => setSelected("existing")}
            >
              <div className="bg-3 border-white border border-3 rounded-circle p-2 d-flex align-items-center justify-content-center">
                <img
                  src="https://goodhand.b-cdn.net/Assets/Flow/packages.svg"
                  alt=""
                  style={{ height: "20px" }}
                />
              </div>
              <div className="d-flex flex-column justify-content-center">
                <p className="p-0 font-12 mb-0 text-main">Select</p>
                <p className="p-0 font-14 mb-0 text-main ff-bold">
                  Existing Applicant
                </p>
              </div>
            </div>
          </div>
        )}
        <div className="col">
          <div
            className={`d-flex align-items-center gap-3 pk-card-nw p-2 rounded-4 ${
              selected === "new" ? "active" : ""
            }`}
            style={{
              cursor: "pointer",
              borderColor: selected === "new" ? "#385986" : "transparent",
            }}
            onClick={() => {
              setSelected("new");
              setApplicantFormData({}); // Clear the form fields
            }}
          >
            <div className="bg-3 border-white border border-3 rounded-circle p-2 d-flex align-items-center justify-content-center">
              <img
                src="https://goodhand.b-cdn.net/Assets/Flow/individual.svg"
                alt=""
                style={{ height: "20px" }}
              />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <p className="p-0 font-12 mb-0 text-main">Add</p>
              <p className="p-0 font-14 mb-0 text-main ff-bold">
                New Applicant
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}

      <div>
        {selected === "existing" ? (
          <>
            {check === true && (
              <div className="row g-3 pt-3 pb-3">
                <div style={{ display: showAll ? "block" : "none" }}>
                  <SearchBar onSearch={setSearchQuery} />
                </div>
                <div
                  className="overflow-auto"
                  style={{ maxHeight: showAll ? "400px" : "auto" }}
                >
                  {/* {filteredUsers } */}
                  {displayedUsers?.map((user) => {
                    const isSelected =
                      selectedUser?.applicantid === user?.applicantid;
                    return (
                      <div className="col-12 mb-3" key={user.applicantid}>
                        <div
                          className="d-flex align-items-center gap-3 pk-card-nw p-2 rounded-4"
                          style={{
                            backgroundColor: isSelected ? "#ffffff" : "#F8F8F8",
                            border: isSelected
                              ? "2px solid #385986"
                              : "2px solid #F8F8F8",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setSelectedUser(user);
                            setSelectedApplicant(user);
                            setApplicantFormData(user);
                          }}
                        >
                          <div className="rounded-circle p-2 d-flex align-items-center justify-content-center">
                            <img
                              src={
                                isSelected
                                  ? "https://goodhand.b-cdn.net/Assets/Flow/selected-userr.svg"
                                  : "https://goodhand.b-cdn.net/Assets/Flow/list-user.svg"
                              }
                              alt="user-icon"
                              style={{ height: "45px" }}
                            />
                          </div>
                          <div className="d-flex flex-column justify-content-center">
                            <p className="p-0 font-12 mb-0 text-main">
                              <span
                                className={`flag-icon flag-icon-${
                                  user.country
                                    ? user.country.toLowerCase()
                                    : "ae"
                                } me-1`}
                              ></span>
                              Passport No : {user.passport}
                            </p>
                            <p className="p-0 font-14 mb-0 text-main ff-bold">
                              {user.name}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {!showAll &&
                  applicantData?.count !== undefined &&
                  applicantData.count > 2 && (
                    <div className="col-12">
                      <div
                        className="bg-3 p-2 text-main col-6 text-center d-block mx-auto font-14 rounded-3 ff-semibold"
                        style={{ cursor: "pointer" }}
                        onClick={handleViewMore}
                      >
                        View more {applicantData?.count - 2} applicant
                      </div>
                    </div>
                  )}
              </div>
            )}
          </>
        ) : (
          <FormWithCountrySelector
            applicantFormData={applicantFormData}
            setApplicantFormData={setApplicantFormData}
            nameError={nameError}
            setNameError={setNameError}
            passportNumberError={passportNumberError}
            setPassportNumberError={setPassportNumberError}
            countryError={countryError}
            setCountryError={setCountryError}
            onProceed={() => {}}
          />
        )}
      </div>

      <style>{`  
  /*--------------form style ----------------------------*/
.custom-input {
height: 45px;
font-size: 14px;
padding: 10px 14px;
border-radius: 8px;
border: 1px solid #ced4da;
background-color: #ffffff;
}

.custom-input::placeholder {
color: #6c757d;
font-weight: 400;
}

.input-error {
border: 2px solid #dc3545;
}

.error-text {
font-size: 12px;
color: #dc3545;
margin-top: 4px;
margin-left: 4px;
}
.pk-card-nw {
cursor: pointer;
transition: 0.2s ease;
border: 2px solid transparent;
}

.pk-card-nw:hover {
background-color: #f8f9fa;
}
.pk-card-nw.active p.text-main {
color: white !important;
}

.pk-card-nw.active {
background-color: #385986;
}  
`}</style>
    </div>
  );
};

export default ApplicantDetails;
